export const DETAIL_TITLE = {
  FEATURES: 'Features',
  PREREQUISITE: 'Prerequisite',
  AUDIENCE: 'Audience',
  OUTCOME: 'Outcome',
  OUTLINE: 'Outline',
  OTHER_RELATED_PRODUCTS: 'Other Popular Products',
  OTHER_RELATED_COURSES: 'Recommended Courses',
  COURSE_PROVIDERS_INFORMATION: 'Course Providers Information',
  KEY_FEATURES: 'Key Features',
  PROVIDER_INFORMATION: 'Provider Information',
  PRODUCT_PROVIDER_INFORMATION: 'Product Provider Information',
};
